import type { PayOverdueBalanceMutation } from '@ctct/state-server-layer';

import { EventBus } from '../../helpers';

type OverduePaymentButtonEvents = {
  payOverdueBalanceClicked: [payOverdueBalanceCall: PayOverdueBalanceMutation['mutateAsync']];
  payOverdueBalanceSuccess: [isSuccess: boolean];
  payOverdueBalanceLoading: [isLoading: boolean];
  payOverdueBalanceError: [errorMessage: string];
};

class OverduePaymentButtonEventBus extends EventBus<OverduePaymentButtonEvents> {}

export const overduePaymentButtonEventBus = new OverduePaymentButtonEventBus();
